/**
 * Shared Framer Motion animation variants — single source of truth.
 *
 * Import instead of re-declaring in each page/component.
 * Compatible with all existing usages (with or without custom index param).
 */

/** Standard fade-up entrance used across most pages */
export const fadeUp = {
    hidden: { opacity: 0, y: 12 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.04,
            duration: 0.35,
            ease: [0.25, 0.46, 0.45, 0.94],
        },
    }),
};

/** Expand/collapse variant (e.g. for accordion panels) */
export const expandVariants = {
    hidden: { height: 0, opacity: 0, overflow: "hidden" },
    visible: {
        height: "auto",
        opacity: 1,
        overflow: "visible",
        transition: { duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] },
    },
};

/**
 * Rozwijanie/zwijanie Z ANIMACJĄ ZAMYKANIA (wariant z osobnym stanem `exit`).
 *
 * [A15-20] BYŁO ZLE: ta definicja mieszkała osobno, w utils/deptPageHelpers.js, jako druga kopia
 * wariantów obok tego pliku — i po cichu się od niego różniła (`overflow: hidden` w stanie visible
 * oraz dodatkowy `exit` 0,2 s, których wersja tutaj nie ma).
 * SKUTEK DLA UŻYTKOWNIKA: ruch interfejsu był niespójny między modułami — zwijane panele
 * na stronach „Mój Dział" zamykały się płynnie, te same panele w innych sekcjach znikały skokowo,
 * a zmiana czasu animacji w jednym pliku nie obejmowała drugiego.
 * NAPRAWA: bogatszy wariant przeniesiony tutaj pod WŁASNĄ nazwą, a deptPageHelpers tylko go
 * re-eksportuje. Celowo NIE scalamy go z `expandVariants` — to dwa różne zachowania i scalenie
 * zmieniłoby animacje na już działających stronach.
 */
export const expandCollapseVariants = {
    hidden: { height: 0, opacity: 0, overflow: "hidden" },
    visible: {
        height: "auto",
        opacity: 1,
        overflow: "hidden",
        transition: { duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] },
    },
    exit: {
        height: 0,
        opacity: 0,
        overflow: "hidden",
        transition: { duration: 0.2 },
    },
};

/** Simple fade (no vertical movement) */
export const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: 0.3 },
    },
};
